import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function ConfirmButtonWithTermsOfUse({ id, showTermsOfUse, enabled, onSubmit }) {
  const { t, i18n } = useTranslation();
  const termsOfUseId = 'termsOfUseAgreement-' + id;
  const [termsOfUseViolation, setTermsOfUseViolation] = useState(false);
  const [termsOfUseChecked, setTermsOfUseChecked] = useState(!showTermsOfUse);

  const handleTermsOfUseChange = (event) => {
    setTermsOfUseChecked(event.target.checked);
  };

  const onConfirm = (event) => {
    event.preventDefault();
    if (termsOfUseChecked) {
      onSubmit?.();
    } else {
      setTermsOfUseViolation(true);
    }
  };

  return (
    <div className="adminTermsConditionsWrap">
      {showTermsOfUse && (
        <div className="adminLoginInput adminLoginInputCheckbox adminTermsConditions">
          <input
            id={termsOfUseId}
            type="checkbox"
            checked={termsOfUseChecked}
            className="form-control"
            onChange={handleTermsOfUseChange}
          />
          <label htmlFor={termsOfUseId}>
            {t("review.agr")}&nbsp;
            <a href={"/pogoji-uporabe?language=" + i18n.language} target="_blank" rel="noreferrer">
              {t("review.terms")}
            </a>
          </label>
        </div>
      )}
      {termsOfUseViolation && !termsOfUseChecked && <p>{t("review.error.terms")}</p>}

      <div className="text-center">
        <button type="button" onClick={onConfirm} className="btn btn-primary btn-lg btn-product" disabled={!enabled}>
          {t("review.en")}
        </button>
      </div>
    </div>
  );
}

export default ConfirmButtonWithTermsOfUse;